import { useEffect } from 'react';

const BASE = 'https://voxmeridian.com';
const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1652888510609-ed2d2ad64d6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200';

const setMeta = (selector, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const m = selector.match(/(name|property)="(.+?)"/);
    el.setAttribute(m[1], m[2]);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
};

export const useSEO = ({ title, description, path = '/', jsonLd, image, robots = 'index, follow' }) => {
  useEffect(() => {
    const url = BASE + path;
    const desc = description || '';
    const shareImage = image || DEFAULT_IMAGE;
    document.title = title;
    setMeta('meta[name="description"]', desc);
    setMeta('meta[name="robots"]', robots);
    setMeta('meta[property="og:site_name"]', 'Vox Meridian');
    setMeta('meta[property="og:type"]', 'website');
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', desc);
    setMeta('meta[property="og:url"]', url);
    setMeta('meta[property="og:image"]', shareImage);
    setMeta('meta[name="twitter:card"]', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', desc);
    setMeta('meta[name="twitter:url"]', url);
    setMeta('meta[name="twitter:image"]', shareImage);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', url);
    let ld = document.head.querySelector('script[data-seo-jsonld]');
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement('script');
        ld.setAttribute('type', 'application/ld+json');
        ld.setAttribute('data-seo-jsonld', 'true');
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, path, jsonLd, image, robots]);
};
